"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionBidDtoStatusEnum = void 0;
exports.instanceOfAuctionBidDto = instanceOfAuctionBidDto;
exports.AuctionBidDtoFromJSON = AuctionBidDtoFromJSON;
exports.AuctionBidDtoFromJSONTyped = AuctionBidDtoFromJSONTyped;
exports.AuctionBidDtoToJSON = AuctionBidDtoToJSON;
exports.AuctionBidDtoToJSONTyped = AuctionBidDtoToJSONTyped;
var AuctionBidBidderDto_1 = require("./AuctionBidBidderDto");
var AuctionBidOfferDto_1 = require("./AuctionBidOfferDto");
/**
 * @export
 */
exports.AuctionBidDtoStatusEnum = {
    Leading: 'leading',
    UnderBid: 'under_bid',
    Won: 'won',
    Cancelled: 'cancelled',
    Withdrawn: 'withdrawn'
};
/**
 * Check if a given object implements the AuctionBidDto interface.
 */
function instanceOfAuctionBidDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('bidAmount' in value) || value['bidAmount'] === undefined)
        return false;
    if (!('bidDateTime' in value) || value['bidDateTime'] === undefined)
        return false;
    if (!('totalBids' in value) || value['totalBids'] === undefined)
        return false;
    if (!('isVendorBid' in value) || value['isVendorBid'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('bidder' in value) || value['bidder'] === undefined)
        return false;
    return true;
}
function AuctionBidDtoFromJSON(json) {
    return AuctionBidDtoFromJSONTyped(json, false);
}
function AuctionBidDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'listingId': json['listingId'],
        'bidAmount': json['bidAmount'],
        'bidDateTime': json['bidDateTime'],
        'totalBids': json['totalBids'],
        'isVendorBid': json['isVendorBid'],
        'status': json['status'],
        'offer': json['offer'] == null ? undefined : (0, AuctionBidOfferDto_1.AuctionBidOfferDtoFromJSON)(json['offer']),
        'bidder': (0, AuctionBidBidderDto_1.AuctionBidBidderDtoFromJSON)(json['bidder']),
    };
}
function AuctionBidDtoToJSON(json) {
    return AuctionBidDtoToJSONTyped(json, false);
}
function AuctionBidDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'listingId': value['listingId'],
        'bidAmount': value['bidAmount'],
        'bidDateTime': value['bidDateTime'],
        'totalBids': value['totalBids'],
        'isVendorBid': value['isVendorBid'],
        'status': value['status'],
        'offer': (0, AuctionBidOfferDto_1.AuctionBidOfferDtoToJSON)(value['offer']),
        'bidder': (0, AuctionBidBidderDto_1.AuctionBidBidderDtoToJSON)(value['bidder']),
    };
}
